import { atom } from 'jotai'

export const tableAtom = atom<boolean>(false)

export const OfferAtomModal = atom<boolean>(false)

export const OfferIdAtom = atom<number>(0)
